// «Обновить» (`POST submit-update`) и «Отменить правки» (`DELETE …/draft`) — одно правило
// на курс и статью: хуки (`useCourseUpdate`, `useArticleUpdate`) держат только свои мутации
// и тексты успеха.
import { toast } from 'sonner'
import { parseModerationError } from './parseModerationError'
import { handleUpdateFailure, type UpdateFailureHandlers } from './updateFailure'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

interface SendArgs<R> extends UpdateFailureHandlers {
  request: () => Promise<R>
  doneText: (res: R) => string
  /** Свежее состояние модерации. Не бросает (initiate без unwrap). */
  refresh: () => PromiseLike<unknown>
}

/** Заявка → тост успеха → свежее состояние модерации; отказ — разбором `parseModerationError`.
 *  Вызывающий держит реф двойного клика до конца промиса, то есть до свежего состояния:
 *  иначе на время одного запроса кнопка снова живая, а редактор ещё не знает про `pending`. */
export const sendDraftUpdate = async <R>({
  request,
  doneText,
  refresh,
  ...handlers
}: SendArgs<R>): Promise<void> => {
  try {
    toast.success(doneText(await request()))
  } catch (err) {
    handleUpdateFailure(parseModerationError(err), handlers)
    return
  }
  await refresh()
}

/** Черновик удаляется целиком, живое не меняется. На отказе — перечитать состояние. */
export const discardDraft = async (request: () => Promise<unknown>, refetch: () => void) => {
  try {
    await request()
    toast.success(messagesNow(messages).draftDiscarded)
  } catch {
    toast.error(messagesNow(messages).draftDiscardFailed)
    refetch()
  }
}
